import React from 'react';

import { Box, Text } from '@adsk/alloy-react-box';
import { BasicButton } from '@adsk/alloy-react-button';
import { ClipboardIcon } from '@adsk/alloy-react-icon';
import theme from '@adsk/alloy-react-theme';

const FormsTemplateItem = ({ template, onClick, onClose }) => {
  return (
    <BasicButton
      onClick={() => {
        onClick(template);
        onClose();
      }}
      style={[
        theme.typography.bodyMedium,
        {
          position: 'relative',
          justifyContent: 'start',
          width: '100%',
          height: '36px',
          padding: '0px 20px',
          cursor: 'pointer',
          color: theme.colors.charcoal900,
          '&:hover': {
            background: theme.colors.charcoal050,
          },
        },
      ]}
    >
      <Box width="24px" marginRight="10px">
        <ClipboardIcon size={24} />
      </Box>

      <Text typography="ellipsis">{template.name}</Text>
    </BasicButton>
  );
};

export default FormsTemplateItem;
